import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Project } from './models/project.model';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import { Http } from '@angular/http/src/http';
import { Account } from 'app/settings/models/account.model';
import { Avdeling } from 'app/settings/models/avdeling.model';
@Injectable()

export class SettingsService {
    apiUrl = environment.apiUrl;
    projects: any;
    accounts: any;
    avdelinger: any;
    constructor(private http: HttpClient) {}

    // PROJECTS FUNCTIONS //

    getProjects(): Observable<Project> {
        if (this.projects) {
            return Observable.of(this.projects);
        } else {
            return this.http.get<Project>(this.apiUrl + '/cp/projects/all').do(res => this.projects = res);
        }
    }

    newProject(model): Observable<Project> {
        return this.http.post<Project>(this.apiUrl + '/cp/projects/new', model);
    }

    updateProject(id, model): Observable<Project> {
        return this.http.put<Project>(this.apiUrl + '/cp/projects/update/' + id, model);
    }

    deleteProject(id): Observable<any> {
        return this.http.delete<number>(this.apiUrl + '/cp/projects/delete/' + id);
    }


    // ACCOUNTS FUNCTIONS //

    getAccounts(): Observable<Account> {
        if (this.accounts) {
            return Observable.of(this.accounts);
        } else {
            return this.http.get<Account>(this.apiUrl + '/cp/accounts/all').do(res => this.accounts = res);
        }
    }

    newAccount(model): Observable<Account> {
        return this.http.post<Account>(this.apiUrl + '/cp/accounts/new', model);
    }

    updateAccount(id, model): Observable<Account> {
        return this.http.put<Account>(this.apiUrl + '/cp/accounts/update/' + id, model);
    }

    deleteAccount(id): Observable<any> {
        return this.http.delete<number>(this.apiUrl + '/cp/accounts/delete/' + id);
    }

     // ACCOUNTS FUNCTIONS //

    getAvdelinger(): Observable<Avdeling> {
        if (this.avdelinger) {
            return Observable.of(this.avdelinger);
        } else {
            return this.http.get<Avdeling>(this.apiUrl + '/cp/avdelinger/all').do(res => this.avdelinger = res);
        }
    }

    newAvdeling(model): Observable<Avdeling> {
        return this.http.post<Avdeling>(this.apiUrl + '/cp/avdelinger/new', model);
    }

    updateAvdeling(id, model): Observable<Avdeling> {
        return this.http.put<Avdeling>(this.apiUrl + '/cp/avdelinger/update/' + id, model);
    }

    deleteAvdeling(id): Observable<any> {
        return this.http.delete<number>(this.apiUrl + '/cp/avdelinger/delete/' + id);
    }

}



// WEBPACK FOOTER //
// ./src/app/settings/settings.service.ts